import { render } from "./ChecklistShow.vue?vue&type=template&id=31defc38"
import script from "./ChecklistShow.vue?vue&type=script&lang=js"
export * from "./ChecklistShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__